import { render } from "./FormTextBox.vue?vue&type=template&id=060ae978"
import script from "./FormTextBox.vue?vue&type=script&lang=js"
export * from "./FormTextBox.vue?vue&type=script&lang=js"
script.render = render

export default script